const { CardDeck, CivilCardTypes } = require("../../Constants/Names/CardTypes");
const Card = require("./Card");

class ActionCard extends Card {
    constructor(action){
        super(
            CardDeck.Civil,
            CivilCardTypes.Action,
            null,
            action.GetName(),
            action.GetAge(),
            action.GetText(),
            {
                playerStateAltering:
                (platerState) => {
                    //do stuff
                }
            }
        )
        this.Action = action
    }
}

module.exports = ActionCard;